<template>
  <v-dialog v-model="dialogShare" max-width="500px">
    <template v-slot:activator="{ props }">
      <v-list-item v-bind="props">
        <template v-slot:prepend>
          <v-icon color="primary" class="full-opacity">mdi-account-plus</v-icon>
        </template>
        <v-list-item-title>{{ $t("labels.share") }}</v-list-item-title>
      </v-list-item>
    </template>
    <v-card height="600px" class="overflow-auto">
      <v-toolbar flat color="secondary">
        <v-toolbar-title class="text-white">
          {{ $t("labels.share-mashup") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon @click="dialogShare = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="mt-5">
        <shareForm
          :share-form-config="shareFormConfig"
          :realm="realm"
          :mashup.sync="mutableMashup"
          :root="'projects'"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import shareForm from "@/components/ShareForm.vue";

export default {
  name: "DialogShare",
  components: { shareForm },
  data() {
    return {
      tenantId: this.realm,
      urlPath: "",
      mashupId: "",
      mutableMashup: {},
      mashupVersion: "",
      dialogShare: false,
    };
  },
  props: {
    realm: String,
    mashup: {},
    shareFormConfig: {},
  },
  mounted() {
    this.mutableMashup = this.mashup;
  },
};
</script>

<style scoped>
.full-opacity {
  opacity: 1 !important;
}
</style>
